import React, { useEffect, useState } from 'react';
import {
	PieChart, Pie, Cell,
} from 'recharts';
import ResponsiveContainer from 'recharts/lib/component/ResponsiveContainer';
import Tooltip from 'recharts/lib/component/Tooltip';
import MediaChartTag from '../MediaChartTag';
import * as Style from './style';
import api from '../../../services/api';
import utils from '../../../services/utils';
import Card from '../Card';
import SectionTitle from '../SectionTitle';
import color from '../../../config/colors.json';

const initialPieChartData = [
	{ name: 'Google', value: 1, color: color.ggreen },
	{ name: 'Facebook', value: 1, color: color.fblue },
	{ name: 'Instagram', value: 1, color: color.igpurple },
];

const CustomTooltip = ({ active, payload }) => {
	if (active) {
		return (
			<Style.StyledTooltip className="custom-tooltip-pie">
				<p className="label">{payload[0].name}</p>
				<p className="intro">{utils.floatToCurrency(payload[0].value)}</p>
			</Style.StyledTooltip>
		);
	}
	return null;
};

const MediaChartsLogged = () => {
	const [total, setTotal] = useState(0);
	const [pieChartData, setPieChartData] = useState(initialPieChartData);
	const [loadedData, setLoadedData] = useState(false);
	const [captions, setCaptions] = useState([]);
	useEffect(() => {
		api.get('/api/v2/alloc')
			.then((response) => {
				setTotal(response.data.data.attributes.total);
				const activeCaptions = [];
				const platforms = ['google', 'facebook', 'instagram'];
				Object.keys(response.data.data.attributes).forEach((item) => {
					if (platforms.includes(item)) {
						activeCaptions.push(item.charAt(0).toUpperCase() + item.slice(1));
					}
				});
				setCaptions(activeCaptions);
				setPieChartData([
					{ name: 'Google', value: response.data.data.attributes.google, color: color.ggreen },
					{ name: 'Facebook', value: response.data.data.attributes.facebook, color: color.fblue },
					{ name: 'Instagram', value: response.data.data.attributes.instagram, color: color.igpurple },
				]);
				setLoadedData(true);
			});
	}, []);

	return (
		<Card padding="20px 14px 13px 20px" border={`1px solid ${color.lightGrey43}`} noShadow height="100%">
			<SectionTitle
				title="Meus investimentos"
				subtitle="Alocação de investimento em campanhas ativas"
				titleHeight="20px"
				titleSize="14px"
				titleMarginBottom="0"
				subtitleHeight="20px"
				subtitleSize="14px"
				subtitleMarginBottom="0"
				marginBottom="33px"
				subtitleColor={color.dark2}
			/>
			<div>
				<Style.PieChartArea>
					{loadedData && (
					<ResponsiveContainer>
						<PieChart>
							<Pie
								data={pieChartData}
								innerRadius="80%"
								outerRadius="100%"
								fill="#8884d8"
								stroke="#00000000"
								paddingAngle={0}
								dataKey="value"
							>
								{
											pieChartData.map((entry, index) => <Cell key={`cell-${index + 1}`} fill={entry.color} />)
										}
							</Pie>
							<Tooltip content={<CustomTooltip />} />
						</PieChart>
					</ResponsiveContainer>
						)}
					<Style.StyledTotalValue>{utils.floatToCurrency(total)}</Style.StyledTotalValue>
				</Style.PieChartArea>
				<Style.PieChartCaption>
					{captions.includes('Google') && (
					<MediaChartTag marginRight="13px" width="26px" height="26px" label={initialPieChartData[0].name} color={initialPieChartData[0].color} />
						)}
					{captions.includes('Facebook') && (
					<MediaChartTag marginRight="13px" width="26px" height="26px" label={initialPieChartData[1].name} color={initialPieChartData[1].color} />
						)}
					{captions.includes('Instagram') && (
					<MediaChartTag marginRight="13px" width="26px" height="26px" label={initialPieChartData[2].name} color={initialPieChartData[2].color} />
						)}
				</Style.PieChartCaption>
			</div>
		</Card>
	);
};

export default MediaChartsLogged;
